import { inject } from "@angular/core";
import { CanActivateFn, Router } from "@angular/router";
import { AuthenticationService } from "../services/authentication.service";
import { map } from "rxjs/operators";

export const DownloadGuard: CanActivateFn = (next, state) => {
  const authService = inject(AuthenticationService);
  const router = inject(Router);

  return authService.authenticatedUser$
    .pipe(
      map(user => {

        if (user?.canDownload) {
          return true;
        }

        return false;
      })
    );
}
